export default __webpack_public_path__ + "static/media/May_09.08287fb8.png";